export const translations: any = {
    id: 'ID',
    name: 'Nombre',
    originalName: 'Nombre',
    lastName: 'Apellidos',
    user: 'Usuario',
    email: 'Email',
    address: 'Dirección',
    cif: 'CIF',
    commercialNetwork: 'Red comercial',
    accessThrowCommercialNetworkIp: 'Acceso IP',
    userRoles: 'Rol',
    empresa: 'Empresa',
    department: 'Departamento',
    logo: 'Logo',
    profileImg: 'Imagen',
    active: 'Activo',
    createdAt: 'Creación',
    date: 'Fecha',
    totalAmount: 'Precio (€)',
    currentContractStatusDate: 'Fecha Estado',
    currentContractStatus: 'Estado Contrato',
    currentContractProductStatus: 'Producto Contrato',
    currentContractInvoicingStatus: 'Facturación Contrato',
    currentContractIncidenceStatus: 'Incidencia Contrato',
    currentInvoicingStatus: 'Estado Factura',
    currentProductStatus: 'Estado Producto',
    currentIncidenceStatusId: 'Estado Incidencia',
    currentCommissionStatusId: 'Estado Comisión',
    product: 'Producto',
    clientProvince: 'Provincia Cliente',
    clientCifNif: 'CIF/NIF Cliente',
    serialCode: 'Código de factura',
    unitPrice: 'Precio unitario (€)',
    kgQuantity: 'Cantidad (kg)',
    ivaTax: 'IVA (%)',
    statusDate: 'Fecha de estado',
    updatedAt: 'Actualización',
    lastLogin: 'Último acceso',
    lastLoginAt: 'Último acceso',
    invoiceNumber: 'Nº factura',
    adnIssueDate: 'Fecha de factura ADN',
    dueDate: 'Fecha de vencimiento',
    paidAmount: 'Importe pagado',
    pendingAmount: 'Importe pendiente',
    overdueDays: 'Días vencidos',
    expirationDate: 'Fecha de expiración',
    paymentDate: 'Fecha de pago',
    invoiceDate: 'Fecha de factura',
    totalPrice: 'Precio total (€)',
    totalProducts: 'Total productos',
    tax: 'IVA',
    totalTaxesAmount: 'Total Impuestos',
    taxableAmount: 'Base Imponible',
    paymentAt: 'Fecha de pago',
    corporation: 'Empresa',
    entityType: 'Entidad',
    documentType: 'Tipo de documento',
    subdirectory: 'Directorio',
    currentStatus: 'Estado',
    status: 'Estado',
    company: 'Organización',
    description: 'Descripción',
    statusOrder: 'Orden',
    productType: 'Tipo de producto',
    draftStatus: 'Borrador',
    initialStatus: 'Inicial',
    satisfactoryStatus: 'Satisfactorio',
    unsatisfactoryStatus: 'Insatisfactorio',
    clientInvoiceStatus: 'Factura cliente',
    tutorInvoiceStatus: 'Factura tutor',
    internalInvoiceStatus: 'Factura interna',
    code: 'Código',
    incidenceType: 'Tipo de incidencia',
    contract: 'Contrato',
    manager: 'Responsable',
    subject: 'Asunto',
    weeklyHours: 'Horas semanales',
    amount: 'Importe',
    nifCif: 'NIF/CIF',
    telephone: 'Teléfono',
    telephoneSecondary: 'Tfno. secundario',
    comments: 'Comentarios',
    documents: 'Documentos',
    availability: 'Disponibilidad',
    platformUser: 'Usuario de plataforma',
    postalCode: 'Código postal',
    province: 'Provincia',
    town: 'Localidad',
    tutorType: 'Tipo de tutor',
    gender: 'Género',
    birthDate: 'Fecha de nacimiento',
    genderViolenceVictim: 'Víctima de violencia de género',
    terrorismVictim: 'Víctima de terrorismo',
    client: 'Cliente',
    other: 'Otros',
    companyName: 'Razón social',
    clientCompanyName: 'Razón social',
    cifNif: 'CIF/NIF',
    cnae: 'CNAE',
    currentCredits: 'Créditos',
    personResponsibleName: 'Nombre (responsable)',
    personResponsibleNif: 'NIF (responsable)',
    lastComment: 'Último comentario',
    comment: 'Comentario',
    credits: 'Créditos',
    entityOrder: 'Orden',
    modifiedAt: 'Fecha de modificación',
    contact: 'Persona de contacto',
    hoursNumber: 'Número de horas',
    orderType: 'Tipo de pedido',
    orderTypes: 'Tipo de pedido',
    contracts: 'Nº contratos',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de fin',
    collectionDate: 'Fecha de cobro',
    orderDate: 'Fecha de pedido',
    calendarDays: 'Días naturales',
    workingDays: 'Días laborables',
    studentName: 'Alumno',
    commercialNetworkName: 'Red comercial',
    commercialName: 'Agente',
    isOnline: 'Online',
    contactPhone: 'Teléfono',
    contactName: 'Contacto',
    contactEmail: 'Correo electrónico',
    location: 'Ubicación',
    alias: 'Alias',
    parkHasClients: 'Parques asignados',
    parkHasUsers: 'Coordinadores',
    commonName: 'Nombre común',
    scientificName: 'Nombre científico',
    family: 'Familia',
    specieIdentifier: 'Identificador de especie',
    acronym: 'Acrónimo',
    censusAvailable: 'Censo disponible',
    ofcAvailable: 'OFC disponible',
    issueAvailable: 'Incidencia disponible',
    catAndalucia: 'Cat Andalucia',
    catNacional: 'Cat Nacional',
    document: 'Imagen',
    issueCode: 'Código',
    park: 'Parque Eólico',
    windturbine: 'Aerogenerador',
    dateReported: 'Fecha de reporte',
    coordinates: 'Coordenadas',
    issuesPhotos: 'Fotos',
    age: 'Edad',
    carrionId : 'Id',
    windTurbine : 'Aerogenerador',
    numMachines : 'Número de Aerogeneradores',
    downtimePerMachine: 'Tiempo parado por Aerogenerador',
    speciesPreventiveStops: 'Especies Observadas',
    stopWithApp: 'Método de parada',
    preventiveStopStatus: 'Estado',
    stopDate: 'Fecha de parada',
    capacity: 'Capacidad',
    category: 'Categoría',
    headquarter: 'Sede',
    teamClients: 'Clientes',
    teamProviders: 'Proveedores',
    teamManagers: 'Gerentes',
    teamParticipants: 'Participantes',
    team: 'Equipo',
    position: 'Cargo',
    plate: 'Matrícula',
    nextDate: 'Próxima ITV',
    brand: 'Marca',
    model: 'Modelo',
    driver: 'Conductor',
    trailer: 'Remolque',
    truck: 'Camión',
    fromDate: 'Fecha Inicio',
    toDate: 'Fecha Fin',
    oldValue: 'Valor Anterior',
    newValue: 'Nuevo Valor',
    changedBy: 'Modificado por',
    fieldName: 'Nombre del campo',
    clientName: 'Cliente',
    quantity: 'Cantidad',
    creator: 'Creador',



};

export const imageFields = [
    'logo',
    'profileImg',
    'document',
];

export const translateColumnName = (key: any) => {
    // Convierte camelCase a "Camel Case"
    const formattedKey = key.replace(/([A-Z])/g, ' $1').trim();

    // Retorna la traducción si existe, o el nombre formateado
    return translations[key] || formattedKey.charAt(0).toUpperCase() + formattedKey.slice(1);
};